import { verifyState } from "config/const";

export const formValidate = (values, props) => {
  const errors = {};
  const emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  if (!values.gender) {
    errors.gender = formState.gender.warning;
  }
  if (!values.firstName) {
    errors.firstName = formState.firstName.warning;
  }
  if (!values.lastName) {
    errors.lastName = formState.lastName.warning;
  }
  if (!values.day || !values.year || !values.month) {
    errors.birthday = formState.birthday.warning;
  }

  if (!values.phone) {
    errors.phone = formState.phone.warning;
  } else if (!values.phone.match(/^(09)[0-9]{8}$/)) {
    errors.phone = formState.phone.format_warning;
  }
  if (props.profile.phone !== values.phone) {
    if (values.phoneVerifyStatus === verifyState.UNVERIFY) {
      errors.verifySms = formState.verifySms.verify_warning;
    }
  }

  if (
    values.phoneVerifyStatus === verifyState.VERIFYING &&
    !values.phoneVerify
  ) {
    errors.verifySms = formState.verifySms.warning;
  }

  // if (!values.email) {
  //   errors.email = "此為必填";
  // }
  if (values.email && !values.email.match(emailFormat)) {
    if (values.email.replaceAll(" ", "") !== values.email) {
      errors.email = formState.email.space_warning;
    } else {
      errors.email = formState.email.format_warning;
    }
  }

  if (!values.branch) {
    errors.branch = formState.branch.warning;
  }

  if (!values.private) {
    errors.private = formState.private.warning;
  }

  return errors;
};

export const formState = {
  lastName: {
    name: "lastName",
    required: true,
    warning: "* 姓氏未填寫",
  },
  firstName: {
    name: "firstName",
    required: true,
    warning: "* 名字未填寫",
  },
  gender: {
    name: "gender",
    required: true,
    warning: "* 稱謂未勾選",
  },
  // the key of birthday is only for view modal
  birthday: {
    name: "birthday",
    warning: "* 生日未填寫",
  },
  birthdayYear: {
    name: "birthdayYear",
    required: true,
  },
  birthdayMonth: {
    name: "birthdayMonth",
    required: true,
  },
  birthdayDay: {
    name: "birthdayDay",
    required: true,
  },
  phone: {
    name: "phone",
    required: true,
    warning: "* 手機未填寫",
    format_warning: (
      <div>
        * 手機格式有誤 <span>應為09XXXXXXXX，請勿輸入空格</span>
      </div>
    ),
  },
  verifySms: {
    name: "verifySms",
    required: true,
    verify_warning: "* 手機未驗證",
    warning: "* 手機驗證碼未填寫",
  },
  email: {
    name: "email",
    required: false,
    format_warning: <div>* 選填項目 - Email格式有誤</div>,
    space_warning: (
      <div>
        * 選填項目 - Email格式有誤 <span>請勿輸入空格</span>
      </div>
    ),
  },
  branch: {
    name: "branch",
    required: true,
    warning: "* 櫃點未填寫",
  },
  private: {
    name: "private",
    required: true,
    warning: "* 請勾選同意條款",
  },
};
